import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  PayGCCResponseData,
  OrderHistoryItem,
  OrderHistoryPagination,
} from "services/paygccService";

export interface PayGCCState {
  paymentData: PayGCCResponseData | null;
  loading: boolean;
  successMsg: {
    message: string;
    id: string;
  };
  errorMsg: {
    message: string;
    id: string;
  };
  orderHistory: OrderHistoryItem[];
  orderHistoryPagination: OrderHistoryPagination | null;
  orderHistoryLoading: boolean;
  orderHistoryError: string | null;
}

export const initialState: PayGCCState = {
  paymentData: null,
  loading: false,
  successMsg: {
    message: "",
    id: "",
  },
  errorMsg: {
    message: "",
    id: "",
  },
  orderHistory: [],
  orderHistoryPagination: null,
  orderHistoryLoading: false,
  orderHistoryError: null,
};

const paygccSlice = createSlice({
  name: "paygcc",
  initialState,
  reducers: {
    setPayGCCLoader(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    payGCCSuccess(state, action: PayloadAction<PayGCCResponseData>) {
      state.paymentData = action.payload;
      state.loading = false;
    },
    payGCCSuccessMsg(state, action: PayloadAction<{ message: string; id: string }>) {
      state.successMsg.message = action.payload.message;
      state.successMsg.id = action.payload.id;
    },
    payGCCErrorMsg(state, action: PayloadAction<{ message: string; id?: string }>) {
      state.errorMsg.message = action.payload.message;
      state.errorMsg.id = action.payload.id || "";
      state.loading = false;
    },
    resetPayGCCState(state) {
      state.paymentData = null;
      state.loading = false;
      state.successMsg = { message: "", id: "" };
      state.errorMsg = { message: "", id: "" };
    },
    setOrderHistoryLoading(state, action: PayloadAction<boolean>) {
      state.orderHistoryLoading = action.payload;
    },
    setOrderHistoryData(
      state,
      action: PayloadAction<{
        orderHistory: OrderHistoryItem[];
        pagination: OrderHistoryPagination;
      }>
    ) {
      state.orderHistory = action.payload.orderHistory;
      state.orderHistoryPagination = action.payload.pagination;
      state.orderHistoryError = null;
    },
    setOrderHistoryError(state, action: PayloadAction<string | null>) {
      state.orderHistoryError = action.payload;
    },
    clearOrderHistoryError(state) {
      state.orderHistoryError = null;
    },
  },
});

export const {
  setPayGCCLoader,
  payGCCSuccess,
  payGCCSuccessMsg,
  payGCCErrorMsg,
  resetPayGCCState,
  setOrderHistoryLoading,
  setOrderHistoryData,
  setOrderHistoryError,
  clearOrderHistoryError,
} = paygccSlice.actions;

export default paygccSlice.reducer;

